module.exports = __webpack_public_path__ + "media/images/home-page/3-5@2x-d93982d39367b2c631d44644693091bd.png";